import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import airdrop_planR from "src/assets/images/airdrop_planR.svg"

export const StakeshotDescription = () => {


    return (
        <>
            <img src={airdrop_planR}
                style={{
                    position: "absolute",
                    bottom: "36px",
                    right: "109px"
                }} />
            <Box>
                <Box>
                    <Typography fontSize="28px" variant="bold" color="#FFFFFF">
                        For the
                        <Typography fontSize="28px" variant="bold" color="#E43E6C"> Rule Maker </Typography>
                        of token distribution
                    </Typography>
                </Box>
                <Box mt="20px">
                    <Typography fontSize="28px" variant="bold" color="#FFFFFF">
                        Staker are valuable players in Crypto
                    </Typography>
                </Box>

                <Box mt="50px">
                    <Typography fontSize="20px" color="#A5A5A5">
                        They staking to protect consensus
                    </Typography>
                </Box>
                <Box mt="10px">
                    <Typography fontSize="20px" color="#A5A5A5">
                        They staking to participate in governance
                    </Typography>
                </Box>
                <Box mt="10px">
                    <Typography fontSize="20px" color="#A5A5A5">
                        While they do not care the tokens’ liquidity
                    </Typography>
                </Box>

                <Box mt="181px">
                    <Typography fontSize="28px" variant="bold" color="#FFFFFF">
                        <Typography fontSize="28px" variant="bold" color="#E43E6C"> Airdrop </Typography>
                        should consider to including stakers
                    </Typography>
                </Box>

                <Box mt="50px">
                    <Typography fontSize="20px" color="#A5A5A5">
                        Let them be part of the genesis
                    </Typography>
                </Box>
                <Box mt="10px">
                    <Typography fontSize="20px" color="#A5A5A5">
                        Let them be part the contributor
                    </Typography>
                </Box>
                <Box mt="10px">
                    <Typography fontSize="20px" color="#A5A5A5">
                        They will show their support
                    </Typography>
                </Box>
            </Box>
        </>
    );
};
